document.addEventListener("DOMContentLoaded", function () {
  const galaxyLink = document.querySelector('a[href="/collections/galaxy-z-fold-series-cases"]');

  if (galaxyLink) {
    // Create submenu container
    const submenu = document.createElement('div');
    submenu.style.display = 'none';
    submenu.style.marginLeft = '20px';
    submenu.style.marginBottom = '8px';

    // Submenu items
    const items = [
    { text: 'Galaxy Z Fold 8 Ultra Cases', realHref: '/collections/galaxy-z-fold-8-ultra-cases' },
    { text: 'Galaxy Z Fold 8 Cases', realHref: '/collections/galaxy-z-fold-8-cases' },
    { text: 'Galaxy Z Fold 7 Cases', realHref: '/collections/galaxy-z-fold-7-cases' }
    ];

    items.forEach(item => {
      const a = document.createElement('a');
      a.href = item.realHref;
      a.textContent = item.text;
      a.className = 'navlink navlink--child';
      Object.assign(a.style, {
        display: 'block',
        margin: '5px 0',
        color: '#000',
        fontSize: '17px',
        fontFamily: 'Poppins, sans-serif',
        lineHeight: '24px',
        fontWeight: '400'
      });
      submenu.appendChild(a);
    });

    // Insert submenu after the main link
    galaxyLink.parentNode.insertBefore(submenu, galaxyLink.nextSibling);

    // Hover behavior
    galaxyLink.addEventListener('mouseenter', () => {
      submenu.style.display = 'block';
      galaxyLink.style.textDecoration = 'underline';
    });

    galaxyLink.addEventListener('mouseleave', () => {
      setTimeout(() => {
        if (!submenu.matches(':hover')) {
          submenu.style.display = 'none';
        }
      }, 150);
      galaxyLink.style.textDecoration = 'none';
    });

    submenu.addEventListener('mouseenter', () => {
      submenu.style.display = 'block';
    });

    submenu.addEventListener('mouseleave', () => {
      submenu.style.display = 'none';
    });
  }

  // Mobile dropdown for iPhone 15 Series
  const links = document.querySelectorAll(".sliderow__title");

  links.forEach(link => {
    if (link.textContent.trim() === "Galaxy Z Fold Series") {
      const parent = link.parentElement;
      let clickTimeout = null;

      link.addEventListener("click", function (e) {
        e.preventDefault();

        if (clickTimeout) {
          clearTimeout(clickTimeout);
          clickTimeout = null;
          window.location.href = link.href || "#";
          return;
        }

        clickTimeout = setTimeout(() => {
          clickTimeout = null;

          let existing = parent.querySelector(".custom-mobile-dropdown");
          if (existing) {
            existing.style.display = existing.style.display === "none" ? "flex" : "none";
            return;
          }

          const dropdown = document.createElement("div");
          dropdown.className = "custom-mobile-dropdown";

          Object.assign(dropdown.style, {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "8px",
            marginBottom: "8px",
            paddingLeft: "25px",
            background: "#fff",
            zIndex: "1"
          });

          const items = [
            { text: 'Galaxy Z Fold 8 Ultra Cases', href: '/collections/galaxy-z-fold-8-ultra-cases' },
            { text: 'Galaxy Z Fold 8 Cases', href: '/collections/galaxy-z-fold-8-cases' },
            { text: 'Galaxy Z Fold 7 Cases', href: '/collections/galaxy-z-fold-7-cases' }
          ];

          items.forEach(item => {
            const a = document.createElement("a");
            a.textContent = item.text;
            a.href = item.href;
            Object.assign(a.style, {
              padding: "10px 0",
              color: "#000",
              textDecoration: "none",
              fontSize: "18px",
              borderBottom: "1px solid #eee"
            });
            dropdown.appendChild(a);
          });

          parent.appendChild(dropdown);

          setTimeout(() => {
            document.addEventListener("click", outsideClickListener);
          }, 10);

          function outsideClickListener(event) {
            if (!dropdown.contains(event.target) && !link.contains(event.target)) {
              dropdown.style.display = "none";
              document.removeEventListener("click", outsideClickListener);
            }
          }
        }, 250);
      });
    }
  });
});
